'use strict'

module.exports = text

var wrapText = require('../util/wrap-text')

function text(h, node) {
  return h(node, 'text', wrapText(h, node.value))
}
